import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import Modal from 'sharedComponents/Modal';
import Icon from 'sharedComponents/Icon';
import useStyles from './useStyles';

const BidRequestCreatingProgress = props => {
  const { progress } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const isAnalyzingFinished = progress > 20;
  const isMatching = progress === 40;
  const isMatchingFinished = progress > 40;
  const isEnteringAnonymous = progress === 80;
  const isFinish = progress === 100;

  return (
    <Modal onClose={() => {}}>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <Box display="flex" alignItems="center">
          <Typography className={clsx(classes.text, classes.active)} variant="body1">
            {t('components.BidRequestCreatingProgress.analyzing')}
          </Typography>
          {isAnalyzingFinished ? (
            <Icon name="done" className={classes.icon} />
          ) : (
            <CircularProgress className={classes.loader} size={20} />
          )}
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography
            className={clsx(classes.text, { [classes.active]: isMatching || isMatchingFinished })}
            variant="body1"
          >
            {t('components.BidRequestCreatingProgress.matching')}
          </Typography>
          {isMatching && <CircularProgress size={20} className={classes.loader} />}
          {isMatchingFinished && <Icon name="done" className={classes.icon} />}
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography
            className={clsx(classes.text, { [classes.active]: isEnteringAnonymous || isFinish })}
            variant="body1"
          >
            {t('components.BidRequestCreatingProgress.enteringAnonymous')}
          </Typography>
          {isEnteringAnonymous && <CircularProgress size={20} className={classes.loader} />}
          {isFinish && <Icon name="done" className={classes.icon} />}
        </Box>
      </Box>
    </Modal>
  );
};

BidRequestCreatingProgress.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default BidRequestCreatingProgress;



// WEBPACK FOOTER //
// ./src/sharedComponents/BidRequestCreatingProgress/BidRequestCreatingProgress.js